export default ".margin\r\n{\r\nmargin-bottom: 5px;\r\n}\r\n";